
import React, { Component } from 'react';
import './styles.scss';
import UserComponent from "../components/User";
import {urlParamToObj} from "../../lib/url-util";

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedWlf: props.wlf ? props.wlf[0].id : false
    };
  }

  render() {
    const path = this.props.location.pathname;
    const url_args = urlParamToObj(this.props.location.search);
    const segment = path === '/user' ? "" : path.substring(6);
    const do_personal = segment === "personal";
    const do_payments = segment === "payments";
    const do_documents = segment === "documents";
    const do_email = segment === "email";
    const do_ugma_invite = segment === "ugma_invite";
    const do_potential = segment === "potential";
    const do_offerings = segment === "offerings";

    // We should have the portfolio account_id specified in a different way
    let acct_id;
    const acct_index = url_args.acct_index === undefined ? 0 :parseInt(url_args.acct_index, 10);
    return (
      <div className="user-page">
        <UserComponent
          acct_index={acct_index}
          acct_id={acct_id}
          personal={do_personal}
          documents={do_documents}
          ugma_invite={do_ugma_invite}
          payments={do_payments}
          potential={do_potential}
          show_email={do_email}
          show_offerings={do_offerings}
          args={url_args}
          path={this.props.location.pathname}
        />
      </div>
    );
  }
}

export default User;
